<style lang="scss" scoped>
  @import '../../../sass/variables';

  .disabled {
    pointer-events: none;
    opacity: 0.5;
  }

  .checkout {
    margin: auto;

    h3 {
      color: $gray-dark;
      font-family: Montserrat;
      font-size: 18px;
      letter-spacing: -0.27px;
      line-height: 30px;
    }
  }

  .board {
    label {
      color: $gray-dark;
      font-family: 'Montserrat';
      font-size: 12px;
      line-height: 16px;
      -webkit-text-stroke: thin;
    }

    hr {
      margin: 30px -25px 10px;

      &.first-divider {
        margin-top: 0px;
      }
    }

    .plans-help {
      margin-top: 17px;
      margin-bottom: 17px;
      color: #857a98;
      font-size: 11px;
      font-weight: 400;
      letter-spacing: -0.17px;
      line-height: 25px;
      -webkit-text-stroke: thin;
    }
  }

  input.discount {
    border: 1px solid $gray-dark;
    background-color: white;
  }

  .checkout-final-button {
    &.btn-light {
      color: $gray-dark;
      background-color: white;
      border: 1px solid $gray-dark;
    }

    &.btn-light:hover,
    &.btn-light.hover {
      color: $gray-dark;
      background-color: #e2e6ea;
      border-color: $gray-dark;
    }

    &.btn-light.disabled,
    &.btn-light:disabled {
      color: $gray-dark;
      background-color: #f8f9fa;
      border-color: $gray-dark;
    }
  }

  .sign-text {
    -webkit-text-stroke: thin;
  }

  @media screen and (min-width: 768px) {
    .digital-sign-buttom {
      font-size: 11px;
    }
  }

  @media screen and (min-width: 992px) {
    .digital-sign-buttom {
      font-size: 9px;
    }
  }

  @media screen and (min-width: 1210px) {
    .digital-sign-buttom {
      font-size: 10px;
    }
  }

  @media screen and (min-width: 1270px) {
    .digital-sign-buttom {
      font-size: 11px;
    }
  }

  @media screen and (min-width: 1440px) {
    .digital-sign-buttom {
      font-size: 13px;
    }
  }

  @media screen and (min-width: 1600px) {
    .digital-sign-buttom {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 1800px) {
    .digital-sign-buttom {
      font-size: 14px;
    }
  }

  @media screen and (min-width: 1920px) {
    .digital-sign-buttom {
      font-size: 14px;
    }
  }
  </style>
  // card with circle title
  <style lang="scss" scoped>
  @import '../../../sass/variables';

  .card-with-circle-header {
    margin-top: 20px;
    margin-bottom: 33px;

    .card-header {
      background-color: transparent;
      padding-bottom: 0px;

      .card-list {
        margin-top: -46px;
        margin-bottom: 20px;

        .card-circle-header {
          max-width: 42px;
          height: 42px;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          z-index: 2;
          width: 100%;

          &__circle-title {
            height: 100%;
            background-color: $gray-dark;
            width: 100%;
            font-size: 17px;
            text-align: center;
            color: $white-gray;
            font-family: Montserrat;
            font-weight: 700;
            line-height: 30px;
            padding-top: 5px;
            border-radius: 50%;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
@import '../../../sass/variables';

.circle-purple-checkbox {
  .custom-control-label:before {
    border-radius: 50%;
    border: 1px solid $purple;
    background-color: white;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: $purple;
    background-color: $purple;
  }

  .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 0.2rem #7123db40;
  }

  .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
    border-color: $purple;
  }

  .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
    color: #fff;
    background-color: #7123db40;
    border-color: #7123db40;
  }
}
</style>

<template>
  <section class="checkout">
    <div class="row">
      <div class="col-md-12">
        <h1 class="page-title">
          {{ __('Pagamento') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h2 class="page-subtitle">
          <i
            class="fa fa-lock"
            aria-hidden="true"
          /><b class="ml-10px">{{ __('Olá') }} {{ user.name | firstword }}</b>, {{ __(title) }}
        </h2>
      </div>
    </div>
    <div class="pt-4">
      <div class="row board pt-4 pb-3">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <div
                class="card card-with-circle-header"
                :class="{ disabled: step != 1 }"
              >
                <div class="card-header">
                  <div class="card-list">
                    <div class="card-circle-header">
                      <div class="card-circle-header__circle-title">
                        1
                      </div>
                    </div>
                  </div>
                  <h3 class="text-center">
                    <b>{{ __('Atualize seus dados') }}</b>
                  </h3>
                </div>
                <div class="card-body">
                  <BillingAccount :user="user" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <div
                class="card card-with-circle-header"
                :class="{ disabled: step != 2 }"
              >
                <div class="card-header">
                  <div class="card-list">
                    <div class="card-circle-header">
                      <div class="card-circle-header__circle-title">
                        2
                      </div>
                    </div>
                  </div>
                  <h3 class="text-center">
                    <b>{{ __('Selecione o plano') }}</b>
                  </h3>
                </div>
                <div class="card-body">
                  <form @submit.prevent="subscribe()">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ __('Plano') }}</label>
                        <select
                          class="form-control"
                          v-model="subscribeForm.plan"
                        >
                          <option value="">
                            {{ __('Selecione') }}
                          </option>
                          <option
                            v-for="plan in plans"
                            :value="plan.provider_id"
                          >
                            {{ plan.name }}
                          </option>
                          <option
                            value=""
                            disabled
                          >
                            Para planos acima de 100.000 consulte o suporte
                          </option>
                        </select>
                      </div>
                      <!-- <div class="col-md-4">
                        <label class="m-l-20">{{ __('Usuários') }}</label>
                        <select
                          class="form-control"
                          v-model="subscribeForm.users"
                        >
                          <option
                            v-for="qty in range"
                            :value="qty"
                          >
                            {{ qty }}
                          </option>
                        </select>
                      </div> -->
                    </div>
                    <div class="form-group row">
                      <div class="d-none col-md-12 plans-help">
                        <a
                          href="https://bulldesk.com.br/planos"
                          target="blank"
                        >
                          {{ __('Em dúvida?') }}

                          <u>{{ __('Clique aqui') }}</u> {{ __('para ver as especificações dos planos.') }}</a>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5 align-self-center">
                        <input
                          class="form-control discount"
                          type="text"
                          :placeholder="__('Possui cupom desconto?')"
                          title="Possui um cupom de desconto?"
                          v-model="subscribeForm.coupon"
                        >
                      </div>
                      <div
                        class="col-md-3 align-self-center"
                        v-if="trial_days_left > 0"
                      >
                        <u class="float-right"><a href="/settings/setup">{{ __('Continuar Trial') }}</a></u>
                      </div>
                      <div :class="{'col-md-7': trial_days_left <= 0, 'col-md-4': trial_days_left > 0}">
                        <BButton
                          class="float-right checkout-final-button"
                          variant="light"
                          type="submit"
                        >
                          <span v-if="subscribing"><i class="fa fa-spin fa-circle-o-notch" /></span><span v-else>{{ __('Confirmar') }}</span>
                        </BButton>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div
                class="card card-with-circle-header"
                v-if="contract.url"
                :class="{ disabled: step != 3 }"
              >
                <div class="card-header">
                  <div class="card-list">
                    <div class="card-circle-header">
                      <div class="card-circle-header__circle-title">
                        3
                      </div>
                    </div>
                  </div>
                  <h3 class="text-center">
                    <b>{{ __('Assinatura do Contrato') }}</b>
                  </h3>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-12">
                      <h5>{{ __('Total:') }}<b> {{ invoice.total | currency }}</b>/ {{ __('mês') }}</h5>
                      <p class="sign-text">
                        {{ __('Valor sujeito a alteração conforme alterações no plano ou número de usuários') }}<br>
                      </p><span class="sign-text">{{ __('Válido por 12 meses') }}</span>
                    </div>
                    <div class="col-md-6 align-self-end">
                      <BButton
                        class="float-right checkout-final-button digital-sign-buttom"
                        variant="light"
                        :href="contract.url"
                        target="_blank"
                      >
                        <span>{{ __('Assinar contrato digitalmente') }}</span>
                      </BButton>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card card-with-circle-header"
                v-if="invoice.url"
                :class="{ disabled: step != 4 }"
              >
                <div class="card-header">
                  <div class="card-list">
                    <div class="card-circle-header">
                      <div class="card-circle-header__circle-title">
                        4
                      </div>
                    </div>
                  </div>
                  <h3 class="text-center">
                    <b>{{ __('Faça o pagamento') }}</b>
                  </h3>
                </div>
                <div class="card-body">
                  <form @submit.prevent="creditCardPayment()">
                    <div class="form-group row">
                      <div class="col-md-12 text-center">
                        <i class="fa fa-credit-card fa-2x text-primary" />
                        <i class="fa fa-credit-card-alt fa-2x text-secondary" />
                        <i class="fa fa-credit-card fa-2x text-purple" />
                        <i class="fa fa-credit-card-alt fa-2x text-pink" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-5 pr-0">
                        <label>{{ __('Número cartão de crédito') }}</label>
                        <Cleave
                          class="form-control"
                          type="text"
                          :options="cleave.creditCard.options"
                          v-model="credit_card.number"
                          :placeholder="__('Digite o número cartão de crédito')"
                          autocomplete="off"
                        /><span
                          class="form-text text-danger"
                          v-show="account.errors.has('credit_card.number')"
                        >{{ account.errors.get('credit_card.number') }}</span>
                      </div>
                      <div class="col-md-2 pr-0">
                        <label>{{ __('Validade/mês') }}</label>
                        <select
                          class="form-control"
                          v-model="credit_card.month_validity"
                        >
                          <option
                            value=""
                            disabled="disabled"
                          >
                            {{ __('Selecione o mês da validade de seu cartão') }}
                          </option>
                          <option
                            v-for="m in 12"
                            :value="m"
                          >
                            {{ m }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-2 pr-0">
                        <label>{{ __('Validade/ano') }}</label>
                        <select
                          class="form-control"
                          v-model="credit_card.year_validity"
                        >
                          <option
                            value=""
                            disabled="disabled"
                          >
                            {{ __('Selecione o ano da validade de seu cartão') }}
                          </option>
                          <option
                            v-for="y in years"
                            :value="y"
                          >
                            {{ y }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label>{{ __('Cód. segurança') }}</label>
                        <input
                          class="form-control"
                          type="number"
                          v-model="credit_card.security_code"
                          :placeholder="__('Digite o mes da validade do cartão')"
                          autocomplete="off"
                        ><span
                          class="form-text text-danger"
                          v-show="account.errors.has('credit_card.security_code')"
                        >{{ account.errors.get('credit_card.security_code') }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5 col-lg-6 col-xl-7 text-right align-self-center">
                        <u><a
                          class="label"
                          :href="invoice.url"
                          target="_blank"
                        >{{ __('Visualizar Fatura') }}</a></u>
                      </div>
                      <div class="col-md-7 col-lg-6 col-xl-5">
                        <BButton
                          class="float-right checkout-final-button"
                          variant="light"
                          type="submit"
                          target="_blank"
                        >
                          <span>{{ __('Pagar com cartão') }}</span>
                        </BButton>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { BButton, BFormCheckbox } from 'bootstrap-vue';
import Cleave from 'vue-cleave-component';
import Strings from '../../services/strings.js';

export default {
  components: {
    BButton,
    BFormCheckbox,
    Cleave,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
    coupon: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      default: 'finalize seu pagamento com segurança',
      required: false,
    },
  },

  data () {
    // Step 1: Cadastro
    // Step 2: Plano
    // Step 3: Contrato
    // Step 4: Fatura

    return {
      step: 0,
      loading: true,
      contract: null,
      subscription: null,
      account: new BulldeskForm({
        address: {
          postalcode: '',
        },
      }),
      searching: false,
      postalCodeFail: false,
      plan: [],
      plans: [],
      range: _.range(3, 20),
      trial_days_left: 0,
      subscribeForm: new BulldeskForm({
        plan: '',
        coupon: this.coupon,
        users: 3,
        extras: [],
      }),
      subscribing: false,
      invoice: {},
      contract: {},
      credit_card: {
        number: '',
        month_validity: '',
        year_validity: '',
        security_code: '',
      },
      cleave: {
        creditCard: {
          options: {
            numericOnly: true,
            creditCard: true,
            delimiter: '.',
          },
        },
        phone: {
          options: {
            numericOnly: true,
            blocks: [0, 2, 4, 5],
            delimiters: ['(', ') ', '-'],
          },
        },
        cep: {
          options: {
            numericOnly: true,
            blocks: [2, 3, 3],
            delimiters: ['.', '-'],
          },
        },
        cpf: {
          options: {
            numericOnly: true,
            blocks: [3, 3, 3, 2],
            delimiters: ['.', '.', '-'],
          },
        },
      },
    };
  },

  watch: {
    'subscribeForm.plan': function (provider_id) {
      const plan = this.getPlan(provider_id);

      this.subscribeForm.users = plan.min_users;

      this.range = _.range(plan.min_users, plan.min_users + 20);
    },
  },

  computed: {
    years () {
      const year = new Date().getYear();
      return Array.from({ length: 10 }, (value, index) => (year + index).toString().substr(-2));
    },
  },

  created () {
    this.getDetails();

    Echo.channel(`tenant.${this.user.account}`)
      .listen('.contract_signed', (e) => {
        console.log(e);

        this.getDetails();
      });
  },

  mounted () {
    Bus.$on('formEditAccountSave', () => {
      this.step = 2;
    });
  },

  methods: {
    getDetails () {
      this.$http.get('/billing/details')
        .then(({ data }) => {
          const { tenant } = data;

          this.plan = data.plan;
          this.plans = data.plans;
          this.trial_days_left = data.trial_days_left;
          this.account = new BulldeskForm(data.tenant);
          this.contract = tenant.contract || {};
          this.invoice = tenant.last_invoice || {};
          this.subscription = tenant.subscription;

          if (! tenant.last_invoice || ! tenant.contract) {
            this.step = 1;
          } else if (tenant.contract && tenant.contract.signed_at === null) {
            this.step = 3;
          } else if (
            tenant.last_invoice
                  && tenant.last_invoice.status === 'pending'
          ) {
            this.step = 4;
          } else {
            this.step = 1;
          }

          Vue.nextTick(() => {
            this.loading = false;
          });
        });
    },

    getPlan (provider_id) {
      return this.plans.find((plan) => plan.provider_id === provider_id);
    },

    subscribe () {
      this.subscribing = true;

      Http.post('/billing/subscribe', this.subscribeForm)
        .then((data) => {
          this.invoice = data.invoice;
          this.contract = data.contract;
          this.subscription = data.subscription;
          this.subscribing = false;

          this.step = 3;

          try {
            fbq('track', 'Subscribe', { value: this.invoice.total, currency: 'BRL' });
          } catch (e) {
            console.warn(e);
          }

          // try {
          //   gtag('event', 'conversion', {
          //     send_to: 'AW-862908766/cy8dCI64x50BEN7iu5sD',
          //     value: invoice.total,
          //     currency: 'BRL',
          //   });
          // } catch (e) {
          //   console.error(e);
          // }
        })
        .catch((data, a) => {
          this.subscribing = false;

          const error = data[Object.keys(data)][0]
                  || 'Ops, não foi possível concluir sua compra.';

          Alert.error(error);
        });
    },

    creditCardPayment () {
      Iugu.setAccountID(window.BulldeskSettings.iuguAccountId); // TODO get from config
      Iugu.setup();

      const names = this.account.name.split(' ');

      const cc = Iugu.CreditCard(
        this.credit_card.number,
        this.credit_card.month_validity,
        this.credit_card.year_validity,
        names[0],
        names[1],
        this.credit_card.security_code,
      );

      const paymentForm = new BulldeskForm({
        payment: {
          token: '',
        },
      });

      const tokenResponseHandler = (data) => {
        if (data.errors) {
          alert(`Erro salvando cartão: ${JSON.stringify(data.errors)}`);
        } else {
          paymentForm.payment.token = data.id;

          Http.post('/billing/payment', paymentForm)
            .then((data) => {
              try {
                fbq('track', 'Purchase', { value: this.invoice.total, currency: 'BRL' });
              } catch (e) {
                console.error(e);
              }

              setTimeout(() => {
                window.location = data.redirect;
              }, 5000);
              console.log(data);
            })
            .catch((data, a) => {
              const error = data[Object.keys(data)]
                    || this.__('Ops, não foi possível concluir sua compra.');

              Alert.error(error);
            });
        }
      };

      Iugu.createPaymentToken(cc, tokenResponseHandler);

      return false;
    },
  },
};
</script>
